
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"40","height":"40","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M28.663 11.555a20.826 20.826 0 00-5.088-1.552.078.078 0 00-.082.038c-.219.384-.463.885-.634 1.28a19.337 19.337 0 00-5.715 0 12.89 12.89 0 00-.643-1.28.08.08 0 00-.082-.04 20.811 20.811 0 00-5.088 1.553.072.072 0 00-.034.028c-3.241 4.766-4.13 9.413-3.693 14.003a.084.084 0 00.032.057 20.865 20.865 0 006.242 3.104.081.081 0 00.088-.027c.482-.645.91-1.329 1.277-2.045a.078.078 0 00-.043-.108 13.76 13.76 0 01-1.95-.914.078.078 0 01-.039-.063.079.079 0 01.031-.068c.131-.097.262-.198.387-.299a.078.078 0 01.082-.01c4.09 1.837 8.52 1.837 12.563 0a.078.078 0 01.082.01c.125.101.255.202.388.3a.078.078 0 01.032.066.077.077 0 01-.039.064c-.622.358-1.27.661-1.95.913a.08.08 0 00-.047.045.079.079 0 00.004.064c.375.716.804 1.397 1.276 2.044a.08.08 0 00.087.03 20.795 20.795 0 006.252-3.106.08.08 0 00.033-.056c.521-5.306-.872-9.916-3.696-14.002a.063.063 0 00-.033-.029zM15.854 22.79c-1.23 0-2.246-1.113-2.246-2.479s.995-2.479 2.246-2.479c1.26 0 2.267 1.122 2.247 2.48 0 1.366-.996 2.478-2.247 2.478zm8.308 0c-1.233 0-2.247-1.113-2.247-2.479s.994-2.479 2.247-2.479c1.26 0 2.266 1.122 2.246 2.48 0 1.366-.985 2.478-2.247 2.478z","fill":"#E13131"}})])
          )
        }
      }
    